enum EventMood {
    Missed = 'missed',
    Poor = 'poor',
    Satisfying = 'satisfying',
    Excellent = 'excellent',
}

export default EventMood;
